export const CONTRACT_LIST_REQUEST = "CONTRACT_LIST_REQUEST";
export const CONTRACT_LIST_SUCCESS = "CONTRACT_LIST_SUCCESS";
